export default {
  existing_documents: {
    description:
      'You have already uploaded the following documents. Select one and press send, or upload a new document instead.',
    sides: {
      front: 'Front',
      back: 'Back',
    },
    created_at: 'Uploaded: {{date}}',
    expires_at: 'Expires: {{date}}',
  },
  document_types: {
    owner_document: 'Owner identity document',
    business_document: 'Business document',
  },
  form: {
    document_type: {
      label: 'Proof of identity document',
      placeholder: 'Select document type',
      options: {
        passport: 'Passport',
        driver_license: "Driver's license",
        id_card: 'Identity card',
        residence_permit: 'Residence permit',
      },
    },
    front: {
      label: 'Document front',
    },
    back: {
      label: 'Document back (optional for some documents)',
    },
    expires_at: {
      label: 'Document expiry date',
      placeholder: 'Select expiry date',
    },
  },
  buttons: {
    select_file: 'Select file',
    next: 'Next',
    back: 'Back',
    send: 'Send',
    upload_new: 'Upload new document',
    use_existing: 'Use an uploaded document',
  },
};
